// Odczyt/zapis liczby w localStorage — proporcje paneli, zoom podglądu itp.
// Zapis i odczyt są odporne na brak dostępu do localStorage (tryb prywatny).

export const readFloat = (
  key: string,
  fallback: number,
  min?: number,
  max?: number,
): number => {
  try {
    const v = parseFloat(localStorage.getItem(key) ?? "");
    if (
      !isNaN(v) &&
      (min === undefined || v >= min) &&
      (max === undefined || v <= max)
    )
      return v;
  } catch {
    /* ignore */
  }
  return fallback;
};

export const writeFloat = (key: string, value: number) => {
  try {
    localStorage.setItem(key, String(value));
  } catch {
    /* ignore */
  }
};
